export class Checkboxes {
    // Finds custom styled checkbox elements and applies CSS to them on load and change.
    // This is only used on about-you and update-contact=details (any page that uses the marketing-request partial).
    public static Init(): void {

        let checkboxes = document.querySelectorAll(".checkbox-control input[type='checkbox']");

        // This works for the about-you checkboxes.
        if (checkboxes.length === 0) {
            // This works for the marketing preferences ones.
            checkboxes = document.querySelectorAll("input[type='checkbox'].checkbox-control");
        }

        if (checkboxes.length) {
            // Set the css class on load to reflect the initial state of ticked items.
            for (const element of checkboxes) {
                if ((element as HTMLInputElement).checked) {
                    element.parentElement.classList.add("checkbox-active");
                }

                element.addEventListener("change", () => {
                    element.parentElement.classList.toggle("checkbox-active");
                });
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => { Checkboxes.Init() });
